import { Controller } from "@hotwired/stimulus"

// EVA-264: raise a notification from a Turbo Stream without an inline <script>.
//
// The streams used to append a <script> that dispatched `show-notification`
// directly. A nonce cannot rescue that: the stream is a *different* response to
// the document it lands in, so its nonce never matches the page's and a strict
// script-src blocks it. Carrying the message as data values instead means the
// markup is inert and Stimulus does the dispatching.
//
// The element removes itself once it has fired, so a stream that appends into a
// long-lived container does not leave a pile of spent markers behind.
export default class extends Controller {
  static values = {
    message: String,
    type: { type: String, default: "success" }
  }

  connect() {
    if (this.messageValue) {
      document.dispatchEvent(
        new CustomEvent("show-notification", {
          detail: { message: this.messageValue, type: this.typeValue }
        })
      )
    }
    this.element.remove()
  }
}
